// extracted by mini-css-extract-plugin
export default {"Emoji":"bcf_a bih_i bih_q bih_j"};